import { CellContent } from '../ToDoTableContent';

export function KonfliktWrapper({
  root,
  cause,
  borderRoot = true,
  borderCause = true,
}: {
  root: React.ReactNode;
  cause: React.ReactNode | null | string;
  borderRoot?: boolean;
  borderCause?: boolean;
}) {
  let renderCause = <CellContent border={borderCause}>{cause}</CellContent>;

  if (cause === null) {
    renderCause = <></>;
  }

  return (
    <div className="flex flex-col">
      <CellContent
        border={borderRoot}
        className={` ${cause === null ? '' : ' border-b-2 border-neutrals-300'}`}>
        {root}
      </CellContent>
      {renderCause}
    </div>
  );
}
